import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { MasterService } from '@app/utility/master.service';
import { FormBuilder} from '@angular/forms';
import { AuthService } from '@app/auth.service';
import { Router } from '@angular/router'; 

declare var $: any

@Component({
  selector: 'app-pre-req-document',
  templateUrl: './pre-req-document.component.html',
  styleUrls: ['./pre-req-document.component.scss']
})
export class PreReqDocumentComponent implements OnInit {

  DataSource1: any = [];
  @ViewChildren('tbCon') tbCon: QueryList<any>; 

  dtCon: any = null
  contactDros: any

  constructor(
    private Util: UtilService,
    private Api: ApiService,
    private router: Router,    
    private util: UtilService 
    ) {


     }

  ngOnInit() {
    $('#Result').addClass("hidden");
  }


  async CancelSearch() {
     $('#dpa_contact_id').val("");
     $('#dpa_contact_account').val("");

  }


  async CreateTable1() {
    let thisTs = this;
    // this.Util.ShowWaiting(true);
      
    var UserName = $('#dpa_contact_id').val();
    var Password = $('#dpa_contact_account').val();

    if (UserName == "") {
      this.util.WarningDialog("กรุณาระบุเลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี");
      return;
    }
    if (Password == "") {
      this.util.WarningDialog("กรุณาระบุหมายเลขบัญชี");
      return;
    }

      let dpa_contact_id = $("#dpa_contact_id").val();
      let dpa_contact_account = $("#dpa_contact_account").val(); 
      let QueryString = "CRM07=true&CRM03=true";
      if (dpa_contact_id != "")
        QueryString += "&dpa_id=" + dpa_contact_id;
      if (dpa_contact_account != "")
        QueryString += "&dpa_accountno=" + dpa_contact_account;         
      let Res: any = await this.Api.get("crmservice", "contactDros", QueryString);
      if(Res == null) {
        this.Util.WarningDialog("ไม่พบข้อมูล");
        return;
      } 
      if (Res.CRM03 == null || Res.CRM03.length == 0) {
        this.Util.WarningDialog("ไม่พบข้อมูล เอกสารที่ขอได้");
        return;
      } 
      Res.CRM03 = Res.CRM03.filter((a: any) => a.FilePath != null && a.FilePath != "" && a.FilePath.split('_')[1] != "05.pdf" && a.FilePath.split('_')[1] != "07.pdf"  ); 
      if (Res.CRM03 == null || Res.CRM03.length == 0) {
        this.Util.WarningDialog("ไม่พบข้อมูล เอกสารที่ขอได้");
        return;
      } 
      if (Res.CRM07 == null || Res.CRM07.length == 0) {
        this.Util.WarningDialog("ไม่พบข้อมูล");
        return;
      }
      else{  
          localStorage.setItem("cusid", dpa_contact_id);
          localStorage.setItem("cusaccno", dpa_contact_account);
          window.location.href =  'mainmenu/reqdocument';
      } 

    
  }

}



// WEBPACK FOOTER //
// ./src/app/pre-req-document/pre-req-document.component.ts